import React, { ComponentProps } from "react";

export default function CollapseIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M14.8535 1.14662C15.049 1.34212 15.049 1.65812 14.8535 1.85362L11.207 5.50012H13.5C13.7765 5.50012 14 5.72412 14 6.00012C14 6.27612 13.7765 6.50012 13.5 6.50012H10C9.726 6.50012 9.5 6.27612 9.5 6.00012V2.50013C9.5 2.22413 9.7235 2.00013 10 2.00013C10.2765 2.00013 10.5 2.22413 10.5 2.50013V4.79313L14.1465 1.14662C14.342 0.951125 14.658 0.951125 14.8535 1.14662Z"
        fill="white"
      />
      <path
        d="M6.50012 10V13.5C6.50012 13.7765 6.27662 14 6.00012 14C5.72363 14 5.50012 13.7765 5.50012 13.5V11.207L1.85362 14.8535C1.65812 15.049 1.34212 15.049 1.14662 14.8535C0.951125 14.658 0.951125 14.342 1.14662 14.1465L4.79313 10.5H2.50013C2.22363 10.5 2.00013 10.2765 2.00013 10C2.00013 9.7235 2.22363 9.5 2.50013 9.5H6.00012C6.27562 9.5 6.50012 9.726 6.50012 10Z"
        fill="white"
      />
      <path
        d="M6.50012 2.50013V6.00012C6.50012 6.27763 6.27163 6.50012 6.00012 6.50012H2.50013C2.22363 6.50012 2.00013 6.27612 2.00013 6.00012C2.00013 5.72412 2.22363 5.50012 2.50013 5.50012H4.79313L1.14662 1.85362C0.951125 1.65812 0.951125 1.34212 1.14662 1.14662C1.34212 0.951125 1.65812 0.951125 1.85362 1.14662L5.50012 4.79313V2.50013C5.50012 2.22413 5.72363 2.00013 6.00012 2.00013C6.27662 2.00013 6.50012 2.22413 6.50012 2.50013Z"
        fill="white"
      />
      <path
        d="M14.8535 14.1465C15.049 14.342 15.049 14.658 14.8535 14.8535C14.658 15.049 14.342 15.049 14.1465 14.8535L10.5 11.207V13.5C10.5 13.7765 10.2765 14 10 14C9.7235 14 9.5 13.7765 9.5 13.5V10C9.5 9.7265 9.7235 9.5 10 9.5H13.5C13.7765 9.5 14 9.7235 14 10C14 10.2765 13.7765 10.5 13.5 10.5H11.207L14.8535 14.1465Z"
        fill="white"
      />
    </svg>
  );
}
